import React, { FC, ReactNode } from "react"
import L10n from "../../../lib/carrot-l10n"
import Title from "../Title"
import { MultiPathSVG } from "../SVG"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

type FleLayoutProps = {
  children: ReactNode
  modal?: ReactNode
}

const FleLayout: FC<FleLayoutProps> = ({ children, modal }) => (
  <>
    <Title title={l`fle.title`} />
    <LogoHeaderBar />
    <MainFleSection>{children}</MainFleSection>
    {modal ? <div>{modal}</div> : null}
  </>
)

const LogoHeaderBar = () => (
  <div className="dn flex-ns justify-center">
    <div
      className="ph4 w-100"
      style={{
        maxWidth: "1224px"
      }}
    >
      <MultiPathSVG iconName="carrot-white" />
    </div>
  </div>
)

type MainFleSectionProps = {
  children: ReactNode
}

const MainFleSection: FC<MainFleSectionProps> = ({ children }) => (
  <div className="flex items-center justify-center">
    <div className="flex justify-center w-100 mw-600 min-h-100vh-s br3 mt4-ns ba-ns bw1-ns b--white mb2-ns pa4-ns pa3">
      <div className="pa3-ns pa2 w-100">
        <div className="flex flex-column h-100">{children}</div>
      </div>
    </div>
  </div>
)

export { FleLayout }
